import HttpHelper from '../../helpers/httpHelper';
import { getSettingUrl, updateSettingUrl } from './setting.uri';

require('dotenv').config();
const headerInfo = {};

class SettingAPI {
    static async UpdateSetting(req) {
        let url = updateSettingUrl();
        return HttpHelper.httpRequest(url, 'POST', headerInfo, req);
    }

    static async GetSetting() {
        let url = getSettingUrl();
        return HttpHelper.httpRequest(url, 'GET', {});
    }

}

export default SettingAPI;
